<template>
  <div
    class="z-20 px-3 pt-6 text-center text-white lg:text-left pb-10 md:px-14"
  >
    <p class="mb-2 font-bold ds-text-2xl">No video...yet</p>

    <template v-if="canRequest">
      <p class="mb-4 ds-text-base font-regular">
        Request video from {{ user.firstName }}'s coach. This is not visible to
        the athlete.
      </p>
      <div class="flex justify-center lg:justify-start">
        <VideoRequestButton source="hero_video" />
      </div>
    </template>
  </div>
</template>

<script>
import VideoRequestButton from "@/components/FeedbackRequest/Types/Video";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    VideoRequestButton,
  },
  computed: {
    ...mapState({
      user: (state) => state.athleteProfile.user,
    }),

    ...mapGetters("athleteProfile", [
      "hasRetrievedBasicInfo",
      "canSendFeedbackRequest",
    ]),

    athleteName() {
      return this.athlete.firstName;
    },

    canRequest() {
      return this.canSendFeedbackRequest;
    },
  },
};
</script>

<style scoped>
</style>